import { jsx, jsxs } from "react/jsx-runtime";
import { Children, Fragment, cloneElement, isValidElement } from "react";
import TooltipPopup from "./TooltipPopup.js";
import useTooltip from "./useTooltip.js";
const Tooltip = ({ children, DEBUG, ...tooltipProps })=>{
    const child = Children.only(children);
    if (!/*#__PURE__*/ isValidElement(child)) throw new Error("You must provide a valid child for the tooltip. Otherwise, there's no tooltip to show");
    const [trigger, tooltip] = useTooltip({
        onMouseEnter: child.props.onMouseEnter,
        onMouseMove: child.props.onMouseMove,
        onMouseLeave: child.props.onMouseLeave,
        onFocus: child.props.onFocus,
        onBlur: child.props.onBlur,
        onKeyDown: child.props.onKeyDown,
        onMouseDown: child.props.onMouseDown,
        ref: child.ref || null,
        DEBUG
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ cloneElement(child, trigger),
            /*#__PURE__*/ jsx(TooltipPopup, {
                ...tooltip,
                ...tooltipProps
            })
        ]
    });
};
const Tooltip_Tooltip = Tooltip;
export default Tooltip_Tooltip;
export { Tooltip };
